// import { theme } from 'config/theme';
import { Theme, useTheme } from '@quillbot/design-system';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  '@keyframes linear-progress-keyframe': {
    from: {
      width: '0%',
    },
    to: {
      width: '100%',
    },
  },
  linearProgress: {
    backgroundColor: theme.palette.primary.main,
    width: '0%',
    animationName: '$linear-progress-keyframe',
    animationDuration: (props: { duration: string }) => props.duration || '5s',
    animationTimingFunction: 'linear',
  },
}));

export default function LinearProgress(props: { showProgress: boolean; duration: number }) {
  const { showProgress, duration } = props;
  const classes = useStyles({ duration: `${duration / 1000}s` });
  const theme = useTheme();
  return (
    <div
      style={{
        width: '100%',
        position: 'relative',
        height: '3px',
        backgroundColor: theme.palette.divider,
      }}
    >
      <div
        style={{
          display: showProgress ? 'block' : 'none',
          height: '3px',
          position: 'absolute',
          top: 0,
          // backgroundColor: '#252525',
        }}
        className={showProgress ? classes.linearProgress : ''}
      />
    </div>
  );
}
